import type { Component } from 'vue'

import type { ListTileTone } from '../../primitives/AppListRow/list-tile-types'
import { LinkedinIcon } from '../../primitives/brand-icons'
import type { ContentChannel } from '../../../types/content'

export type SchedulePlatform = ContentChannel

export const PLATFORM_LABELS: Record<SchedulePlatform, string> = {
  linkedin: 'LinkedIn',
}

/** The mark of each platform. */
export const PLATFORM_ICONS: Record<SchedulePlatform, Component> = {
  linkedin: LinkedinIcon,
}

/** The list tile tone of each platform, in the platform's own colour. */
export const PLATFORM_TILE_TONES: Record<SchedulePlatform, ListTileTone> = {
  linkedin: 'linkedin',
}
